import { jsxs, jsx } from "react/jsx-runtime";
const IconTreeSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 13 14",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M9.666 2.333A3.24 3.24 0 0 0 8 2.793a4 4 0 0 0-7.667 1.54V7a4 4 0 0 0 3.333 3.94V13A.667.667 0 1 0 5 13v-2.06a4.054 4.054 0 0 0 1.853-.84A3.333 3.333 0 0 0 9 11.6V13a.667.667 0 1 0 1.333 0v-1.4A3.333 3.333 0 0 0 13 8.333V5.667a3.333 3.333 0 0 0-3.334-3.334ZM6.333 5.667v2.666c.006.128.02.254.04.38A2.667 2.667 0 0 1 5 9.58V7.667a.667.667 0 1 0-1.334 0v1.906a2.667 2.667 0 0 1-2-2.573V4.333A2.667 2.667 0 0 1 6.22 2.44c.36.366.606.83.706 1.333a3.333 3.333 0 0 0-.593 1.894Zm5.333 2.666a2 2 0 0 1-1.333 1.88V7.667a.666.666 0 1 0-1.333 0v2.546a2 2 0 0 1-1.334-1.88V5.667a2 2 0 1 1 4 0v2.666Z" })
    ]
  }
);
export {
  IconTreeSvg
};
